import { useEffect, useState } from 'react';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import PredictionModelsField from '../component/PredictionModelsField';
import PredictionTypeEditService from '../service/PredictionTypeEditService';

const config = data => ({
	key: 'predictionTypeEditForm',
	text: 'Prediction Type',
	textKey: 'predictionType',
	service: PredictionTypeEditService,
	editableAccess: data.formData.editableAccess,
	editableFields: data.formData.editableFields,
	saveLink: () => '/prediction-type',
	tabList: [
		{
			key: 'info',
			text: 'Info',
			textKey: 'info'
		},
		{
			key: 'models',
			text: 'Models',
			textKey: 'models'
		}
	],
	fields: [
		{
			key: 'name',
			text: 'Name',
			textKey: 'name',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'sourceDeviceType',
			text: 'Source Device Type',
			textKey: 'sourceDeviceType',
			component: EditFormSelectField,
			items: data.formData.entityMap?.sourceDeviceType || [],
			required: true
		},
		{
			key: 'targetDeviceType',
			text: 'Target Device Type',
			textKey: 'targetDeviceType',
			component: EditFormSelectField,
			items: data.formData.entityMap?.targetDeviceType || [],
			required: true
		},
		{
			key: 'bucketMs',
			text: 'Bucket size (ms)',
			textKey: 'bucketMs',
			component: EditFormTextField,
			type: 'number',
			required: true
		},
		{
			key: 'models',
			text: 'Models',
			textKey: 'models',
			tab: 'models',
			component: PredictionModelsField,
			defaultValue: [],
			fields: [
				{
					key: 'name',
					text: 'Name',
					textKey: 'name',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'metadataJson',
					text: 'Metadata JSON',
					textKey: 'metadataJson',
					component: EditFormTextField,
					multiline: true,
					required: true
				}
			]
		}
	]
});

function PredictionTypeEditForm() {
	const [formData, setFormData] = useState(null);

	useEffect(() => {
		PredictionTypeEditService.getFormData().then(result => setFormData(result));
	}, []);

	if (formData == null) return <></>;

	return <EditFormPage config={config({ formData })} />;
}

export default PredictionTypeEditForm;
